import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';  
import { GlobalComponent } from 'src/app/global/global.component';
import { GetListBasenote} from './employee-notes.model';

@Injectable({
  providedIn: 'root'
})

export class EmployeeNotesDateService extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
    super();
  }
 
  public executes(ANState: GetListBasenote): void {
    this.getnotes(ANState).subscribe(x => super.next(x));
  }

  getnotes(ANState?: GetListBasenote): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/EmployeeNote/GetEmpNotesbyFilter?", ANState)
      .pipe(map(
        (response: any) =>
          <any>{
            count: response['count'],
            result: response['result']
          
          }
      ))
  }
}